import { Text } from "@overmap-ai/blocks"
import type { Form, Stored } from "@overmap-ai/common"
import { forwardRef, memo } from "react"

import {
	MentionListEmpty,
	MentionListItem,
	type MentionListRef,
	MentionListRoot,
	type MentionListRootProps,
} from "../../blocks"

type FormMentionListProps = MentionListRootProps<Stored<Form>>

export const FormMentionList = memo(
	forwardRef<MentionListRef<Stored<Form>>, FormMentionListProps>((props, ref) => {
		const { items } = props

		return (
			<MentionListRoot<Stored<Form>> ref={ref} {...props}>
				{items.map((form) => (
					<MentionListItem<Stored<Form>> item={form} key={form.uuid}>
						<Text className="truncate">{form.name}</Text>
					</MentionListItem>
				))}
				<MentionListEmpty>No results</MentionListEmpty>
			</MentionListRoot>
		)
	}),
)
FormMentionList.displayName = "FormMentionList"
